import zh_CN from '../../d-date-picker/locale/zh_CN';
export default zh_CN;
